export default __webpack_public_path__ + "static/media/sum1.923df92d.jpg";